<div class="page-content page-fill">
  <div class="card mb-3">
    @if (!proposalInfo) {
      <div>Loading......</div>
    }
    @if (proposalInfo) {
      <div class="card-body">
        <div class="m-3">
          <h2>Code {{ userCode }}</h2>
        </div>
        <div class="m-3">
          <h2>{{today.getFullYear()}} NOMINATIONS</h2>
          @if (!proposalInfo.voteDate) {
            <h4>Male professing members between the age of 18 and 75</h4>
          }
        </div>
        @if (!proposalInfo.voteDate && !voteExpired) {
          <div class="d-flex  justify-for-phone" style="max-width: 800px">
            <div class="m-1 d-flex align-items-center">
              <div class="d-flex flex-column">
                <label class="me-2">Deacon</label>
                @for (nomination of deacons; track nomination) {
                  <div>
                    <dx-select-box class="flex-fill" [(value)]="nomination.id" [items]="members" valueExpr="Id" displayExpr="Name" [readOnly]="!canVote"></dx-select-box>
                  </div>
                }
              </div>
            </div>
            <div class="m-1 d-flex align-items-center">
              <div class="d-flex flex-column">
                <label class="me-2">Shepherding Elder</label>
                @for (nomination of sheps; track nomination) {
                  <div>
                    <dx-select-box [(value)]="nomination.id" [items]="members" valueExpr="Id" displayExpr="Name" class="flex-fill"></dx-select-box>
                  </div>
                }
              </div>
            </div>
            <div class="m-1 d-flex align-items-center">
              <div class="d-flex flex-column">
                <label class="me-2">Executive Elder</label>
                @for (nomination of execs; track nomination) {
                  <div>
                    <dx-select-box [(value)]="nomination.id" [items]="members" valueExpr="Id" displayExpr="Name" class="flex-fill"></dx-select-box>
                  </div>
                }
              </div>
            </div>
          </div>
        }
        @if (!proposalInfo.voteDate && !voteExpired) {
          <button class="mt-3 ms-4 btn btn-success {{ proposalInfo.Voted && proposalInfo.YesVote ? ' border-class' : '' }}" (click)="submit()">
            Submit
          </button>
        }
        @if (!proposalInfo.voteDate && !voteExpired) {
          <button class="mt-3 ms-4 btn btn-secondary" (click)="clear()">Clear Names</button>
        }
        @if (proposalInfo && proposalInfo.voteDate) {
          <div class="m-3">
            <h3>Thanks for voting!</h3>
          </div>
        }
        @if (proposalInfo && proposalInfo.voteDate) {
          <div class="m-3">You voted on {{ proposalInfo.voteDate }}</div>
        }
        @if (proposalInfo && !proposalInfo.voteDate && !voteExpired) {
          <div class="m-3">
            <h3>The voting process is open until: {{endDate}}</h3>
          </div>
        }
        @if (proposalInfo && voteExpired) {
          <div class="m-3">
            <h3>The voting process is closed</h3>
          </div>
        }
        @if (currentCouncil && currentCouncil.length > 0 && !proposalInfo.voteDate) {
          <div>
            <h4 class="mt-4">CURRENT AND PREVIOUS COUNCIL MEMBERS (excluded from list)</h4>
            <!-- Desktop: Two columns -->
            <div class="d-none d-md-flex">
              <!-- Current Members Column -->
              <div class="col-md-6 pe-2">
                <h5>Current Members</h5>
                <table class="table mt-3">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Committee</th>
                      <th>EndDate</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (member of getCurrentMembers(); track member) {
                      <tr>
                        <td>{{ member.Name }}</td>
                        <td>{{ member.Committee }}</td>
                        <td>{{ member.ending }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
              <!-- Previous Members Column -->
              <div class="col-md-6 ps-2">
                <h5>Previous Members</h5>
                <table class="table mt-3">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Committee</th>
                      <th>EndDate</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (member of getPreviousMembers(); track member) {
                      <tr>
                        <td>{{ member.Name }}</td>
                        <td>{{ member.Committee }}</td>
                        <td>{{ member.ending }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
            <!-- Mobile: Single column (existing layout) -->
            <div class="d-md-none">
              <table class="table mt-3">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Committee</th>
                    <th>EndDate</th>
                  </tr>
                </thead>
                <tbody>
                  @for (member of currentCouncil; track member) {
                    <tr>
                      <td class="col-xs-5">{{ member.Name }}</td>
                      <td class="col-xs-5">{{ member.Committee }}</td>
                      <td class="col-xs-1">{{ member.ending }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
